<template>
    <div class="page-one record-page">
        <div class="record-page-content">
            <div class="record-title">
                <div class="record-top-back" @click="clickBack"><span></span></div>
                <!-- <span class="record-back" @click="clickBack"><i class="iconfont icon-xiangzuo"></i></span> -->
                测算记录
            </div>
            <div class="record-list-box" v-if="userRecordList.length > 0">
                <div class="record-list clearfix">
                    <div class="record-list-item" @click="clickItem(rData)" v-for="rData in userRecordList" v-bind:key="rData.id">
                        <span class="record-item-title">{{rData.f_name}}</span>
                        <i class="record-item-icon iconfont icon-xiangyou"></i>
                    </div>
                </div>
            </div>
            <div class="record-list-note" v-else>
                <div class="no-record">暂时没有数据...</div>
            </div>
        </div>
    </div>
</template>

<script>
import { WEIXIN } from '../modules/weixin';
export default {
    computed: {
        userData() {
            return this.$store.state.userData;
        },
        userRecordList() {
            return this.$store.state.user.userRecordList;
        },
    },
    data() {
        return {
        }
    },
    mounted() {
        setTimeout(() => {
            this.initDom();
            this.$store.dispatch('user/getUserRecordList');
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.height = innerHeight+'px';
        },
        clickBack() {
            this.$router.replace('/index');
        },
        clickItem(rData) {
            let me = this;
            this.$store.dispatch('user/getUserHomePageData', {
                id: rData.id,
                rData: rData,
                cb: function() {
                    // 跳转到过渡页面
                    me.$router.replace('/report');
                }
            })
        }
    }
}
</script>

<style scoped>
.record-page {
    width: 100%;
	height: 100%;
    background-color: #FFE5C8;
	background-image: url('http://m1.2048.net/duoniu/images_vehicle/index-bg.png');
	background-repeat: no-repeat;
	background-size: 100% 100%;
	background-position: center top;
}
.record-page-content  {
	width: 90%;
	height: 90%;
	margin: 3% auto;
	border-radius: 10px;
    background: #FFE5C8;
}
.record-top-back {
	position: absolute;
	left: 0;
	top: 0;
	padding: 10px 15px 15px;
}
.record-top-back span {
	display: block;
	width: 1.5rem;
	height: 1.5rem;
	background: url('http://m1.2048.net/duoniu/images_rabbit/report/report-back.png');
	background-repeat: no-repeat;
	background-size: 100% auto;
	background-position: center top;
}
.record-title {
    height: 2.5rem;
    line-height: 2.5rem;
    font-size: 0.75rem;
    text-align: center;
	color: #CC190D;

    position: relative;
}
.record-back {
    width: 2rem;
    height: 2rem;
    position: absolute;
    left: 0;
    top: 0;
}
.record-back .iconfont {
    font-size: 1.25rem;
}
.record-list-box {
    height: 320px;
    overflow-y: scroll;
    scroll-behavior:smooth; 
}
.record-list-note {
    height: 150px;
}
.record-list {
    padding: 0 20px 50px;
}
.record-list-item {
    float: left;
    width: 43%;
    height: 2rem;
    line-height: 2rem;
    font-size: 0.75rem;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 2px rgba(0,0,0,0.1);
    border-radius: 10px;
    margin: 10px 3.5%;
}
.record-item-title {
    padding-left: 1rem;
    display: inline-block;
    width: 92%;
}
.record-item-icon {
    color: #CCCCCC;
}
.no-record {
	color: #CC190D;
    text-align: center;
    padding-top: 110px;
    font-size: 0.75rem;
}
</style>